import { Component, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../animations/form-error';
import { BasePageComponent } from '../../../base-page';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Costs, ICosts } from '../../../../model/costs.model';
import { Observable, Subject } from 'rxjs';
import { BaseService } from '../../base/base.service';
import { AccountService } from '../../../../services/ServiceEntity/account.service';
import { FormService } from '../../../../shared/services/form.service';
import { TCModalService } from '../../../../ui/services/modal/modal.service';
import { CostsService } from '../../costs/costs.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../interfaces/app-state';
import { HttpService } from '../../../../services/http/http.service';
import { filter, map, startWith, takeUntil } from 'rxjs/operators';
import { SUFFIX_ICON_FORM, WIDTH_MEDIUM_POPUP_CLASS } from '../../../../shared/constant/css-style/css-class.constant';
import { CostsDetails, ICostsDetails } from '../../../../model/costs-details.model';
import { CostsDetailsService } from '../costs-details.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { TIME_MIN_REQUEST, TIME_MIN_X_REQUEST } from '../../../../shared/constant/request.contant';

/**
 * Permet de gérer la modification des détails de coût.
 */
@Component({
  selector: 'app-costs-details-update',
  templateUrl: './costs-details-update.component.html',
  animations: [fadeIn]
})
export class CostsDetailsUpdateComponent extends BasePageComponent
  implements OnInit, OnDestroy {
  isSaving = false;
  successSave = false;
  serverHasError = false;
  theDialogRef: MatDialogRef<CostsDetailsUpdateComponent>;
  editForm: UntypedFormGroup;
  private countrySelected: ICostsDetails;

  // informations sur les type de coûts.
  costsSelected: Costs;
  costsList: Costs[] = [];
  filteredOptions: Observable<Costs[]>;

  private subs$ = new Subject<void>();

  constructor(
    public baseService: BaseService,
    private accountService: AccountService,
    private dialogRef: MatDialogRef<CostsDetailsUpdateComponent>,
    private formService: FormService,
    private fb: UntypedFormBuilder,
    private modal: TCModalService,
    private costsService: CostsService,
    private costsDetailsService: CostsDetailsService,
    store: Store<IAppState>, httpSv: HttpService) {
    super(store, httpSv);
    console.log('## construct costs details update');
    this.theDialogRef = this.dialogRef;
    this.initForm(fb);
  }

  ngOnInit(): void {
    console.log('## init costs details update');
    this.accountService.identity().pipe(takeUntil(this.subs$)).subscribe(res => {
      this.costsDetailsService.getObjetSelectObs()
        .pipe(takeUntil(this.subs$)).subscribe((res: ICostsDetails) => {
        console.log('## get costs details selected to liste');
        try {
          this.getCostsList(res);
        }catch (e) {
          console.log('## error get costs details selected: ' + e.message);
        }
      });
    })
    super.setLoaded();
  }

  ngOnDestroy() {
    console.log('## destroy costs update');
    this.successSave = false;
    this.formService.free(this.subs$);
    this.costsService.setObjetSelectObs(undefined);
  }

  displayFnCosts(subject: ICosts) {
    return subject ? subject.label : '';
  }

  /**
   * remplit le formulaire avec le type détail
   * de coût sélectionné
   * @param res le détail de coût sélectionné
   */
  updateForm(res: ICostsDetails) {
    console.log('## data: ', res);
    this.countrySelected = res;
    this.editForm.patchValue({
      'id': res.id,
      'label': res.label,
      'costs': res.type
    })
  }

  /**
   * Permet de récupérer la liste des coûts
   * @param costsDetailsSelected le type de coût sélectionné
   */
  getCostsList(costsDetailsSelected: ICostsDetails) {
    setTimeout(() => {
      this.costsService
        .query(this.costsService.typesUrl)
        .pipe(
          filter((mayBeOk: HttpResponse<Costs[]>) => mayBeOk.ok),
          map((response: HttpResponse<Costs[]>) => response.body)
        )
        .subscribe((res: Costs[]) => {
            console.log('## success get list costs while adding.');
            const rs = res ? res : [];
            console.log('## size: ' + rs.length);
            this.costsList = rs;
            setTimeout(() => {
              this.updateForm(costsDetailsSelected);
            }, TIME_MIN_X_REQUEST);

            this.filteredOptions = this.editForm.get('costs').valueChanges
              .pipe(
                startWith(''),
                map(value => this._filter(value))
              );
          },
          (res: HttpErrorResponse) => {
            console.log('## error get list costs while adding: ' + res.message);
          });
    });
  }

  /**
   * Permet de faire des recherches sur les coûts.
   * @param value la valeur à rechercher
   * @private
   */
  private _filter(value: string): Costs[] {
    let filteredList;
    try {
      const filterValue = value.toLowerCase();
      filteredList = this.costsList.filter(option => option?.label?.toLowerCase()
        .includes(filterValue));
    } catch (e) {
      console.log('## error filter costs: ' + e.message);
    }
    return filteredList;
  }

  getWidthPopupClass() {
    return WIDTH_MEDIUM_POPUP_CLASS;
  }

  getSuffixIconForm(): string {
    return SUFFIX_ICON_FORM;
  }

  initForm(fb: UntypedFormBuilder) {
    if (fb) {
      this.editForm = fb.group({
        'id': [''],
        'label': ['', [Validators.required]],
        'costs': ['', [Validators.required]]
      })
    }
  }

  /**
   * permet de modifier un coût existant.
   */
  save() {
    console.log('update costs details');
    this.isSaving = true;
    this.successSave = false;
    this.serverHasError = false;
    const c: ICostsDetails = this.createFromForm();
    console.log('## c: ', c);
    this.costsDetailsService.update(c, this.costsDetailsService.typesUrl)
      .subscribe(res => {
          console.log('## success update costs details');
          this.serverHasError = false;
          this.responseFromServer();
          this.editForm.markAsPristine();
          this.successSave = true;
          this.costsDetailsService.getAllObjet();
          this.closeModal();
        },
        err => {
          console.log('## error update costs: ', err);
          this.responseFromServer();
          this.serverHasError = true;
          this.successSave = false;
        });
  }

  responseFromServer() {
    setTimeout(() => {
      this.isSaving = false;
    }, 300)
  }

  private createFromForm(): ICostsDetails {
    return {
      ...new CostsDetails(),
      id: this.editForm.get('id').value,
      label: this.editForm.get('label').value,
      typeId: (this.editForm.get('costs').value as ICostsDetails).id,
    };
  }

  closeModal() {
    console.log('## close costs update');
    this.dialogRef.close();
    this.successSave = false;
    this.serverHasError = false;
    this.editForm.reset();
  }

}
